export enum OrderGenerationType {
  CODE_GENERATION_UNKNOWN = 'UNKNOWN',
  CODE_GENERATION_WARRANTY = 'WARRANTY',
  CODE_GENERATION_ITEM = 'ITEM',
  CODE_GENERATION_AGGREGATED_PRODUCT = 'AGGREGATED_PRODUCT',
  CODE_GENERATION_SECURITY_PASSCODE = 'SECURITY_PASSCODE',
}
